import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import './styles.scss'
import Heading from '../heading/Heading';
import Input from '../form/inputs/Input';
import Button from '../buttons/Button';
import Select from '../form/selects/Select';
import UploadDragDropFiles from '../upload-drag-drop-files/UploadDragDropFiles';
import creditTypes from './../../static-data/credit-types.json';
import FileList from '../file-list/FileList';
import validateFile from './../../services/validateFile';
import CheckboxRadio from '../form/checkbox/CheckboxRadio';

const OtherCredits = ( props ) => {
    let [ buttonError, setButtonError ]             = useState(false);
    let [ buttonText, setButtonText ]               = useState("Wczytaj / Przeciągnij plik z wykazem zobowiązań");
    let [ disabledButton, setDisabledButton ]       = useState(false);
    let [ update, setUpdate ]             = useState(0);
    const dispatch                        = useDispatch()
    let otherCreditsFiles                  = useSelector(state => state.otherCreditsFiles)
    let otherCreditsItems                  = useSelector(state => state.otherCreditsItems)
    let statementCreditsPaymentCheckbox    = useSelector(state => state.statementCreditsPaymentCheckbox)
    let [ updateArray, setUpdateArray ]    = useState(0);
    
    async function wait(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
      }
      
      
    useEffect(() => {
        setUpdate(update + 1);
    }, [otherCreditsFiles]);

      let setFiles = (val) => {
          let files = otherCreditsFiles;
          for (let i = 0; i < val.length; i++) {
              const el = val[i];
              let validate = validateFile(1048576, 2, files.length, el);
              setButtonError( validate.error )
              setButtonText( validate.message )
              if ( !validate.error ) {
                files.push(el);
              }
          }          
          dispatch({ type: 'OTHER_CREDITS_FILES_CHANGE', value: files })
          setUpdate(++update);
      }
      let removeFile = ( index ) => {
            let files = otherCreditsFiles;
            files.splice( index, 1);   
            dispatch({ type: 'OTHER_CREDITS_FILES_CHANGE', value: files })
            setUpdate(--update);
            setButtonError( false )
            setButtonText( 'Przeciągnij plik / <br /> Wczytaj z dysku' )
      }

      let add = () => {
        let item = {
                "typeCredit": '',
                "descCredit": '',
                "priceToEnd": '',
                "creditStartDate": '',
                "creditEndDay": '',
            }
        let copy = otherCreditsItems;

        if ( copy.length < 5 ) {
            copy = [...copy, item];
            dispatch({ type: 'OTHER_CREDITS_ITEMS_CHANGE', value: copy })
            setDisabledButton(false);
            
        }
        if ( copy.length === 5 ) {
            setDisabledButton(true);
        }
      }
      
    let updateValue =  async( val, index, property ) => {
        let copyArray = otherCreditsItems;
        copyArray[index][property] = val;
        await dispatch( {type: 'OTHER_CREDITS_ITEMS_CHANGE', value:  copyArray } )
        await setUpdateArray(++updateArray);
    }

    let removeLastFromArray = async () => {
        let copyArray = otherCreditsItems;
        await copyArray.splice(-1, 1);
        await dispatch({ type: 'OTHER_CREDITS_ITEMS_CHANGE', value: copyArray })
        await setUpdateArray(++updateArray);
    }

    return (
        <div className="real-estates other-credits">
            <Heading title="Inne Zobowiązania" medium smallMargin /> 
            <Heading title="Kredyty, leasingi, pożyczki, inne" small />
            <div className="row">
                {/* <Heading title="Dodaj wykaz zobowiązań" /> */}
                { update && update >= 0 &&
                    <UploadDragDropFiles setFunction={ ( val ) => setFiles(val)  }
                        buttonText={ buttonText }
                        error={ buttonError } 
                        update={update}
                        tip={ true } 
                        tipHeader="Wczytaj plik"
                        tipText="Wczytaj plik w formacie .jpg lub .pdf. Waga pojedynczego pliku nie może być większa niż 1MB. Maksymalnie można załączyć 2 pliki." /> 
                }
                { otherCreditsFiles.length > 0  &&
                    <FileList   update={ update } 
                                files={ otherCreditsFiles }
                                remove={ ( val ) => removeFile( val ) } />
                }
                <Heading title="lub uzupełnij informacje o zobowiązaniach" small />
                <div className="items">
                    { updateArray >= 0 && otherCreditsItems && otherCreditsItems.map((item, index) => (
                        <>
                        {index > 0 &&
                            <div className="line big" />
                        }
                        <div className="inputs">
                            <div className="col">
                                <Select
                                    id={"othercredits-type-commitment-"+index}
                                    data={ creditTypes }  
                                    forceValidate={ props.forceValidate } 
                                    placehold="Typ zobowiązania" 
                                    val={ item.typeCredit }
                                    setFunction={ val => updateValue(val, index, 'typeCredit')  }  />
                            </div>
                            <div className="col">
                                <Input name={"desc-credit-"+index}
                                    id={"othercredits-desc-credit-"+index}
                                    required={ false }
                                    setFunction={ val =>  updateValue(val, index, 'descCredit')  }
                                    type="text"
                                    placehold={ "Opis zobowiązania" }
                                    val={ item.descCredit }
                                    size="xxl" 
                                    regExp={ null }
                                    minChar={ 0 } 
                                    forceValidate={ props.forceValidate }
                                    forceValidateItems={ props.forceValidateItems } />
                            </div>
                            <div className="col">
                                <Input name={"price-"+index}
                                    id={"othercredits-price-"+index}
                                    required={ false }
                                    setFunction={ val =>  updateValue(val, index, 'priceToEnd')  }
                                    type="text"
                                    placehold={ "Pozostało do spłaty (PLN)" }
                                    val={ item.priceToEnd }
                                    size="xxl" 
                                    formatPrice={ true }
                                    regExp={/^[0-9\,\.\s]+$/}
                                    allowChars={/^[0-9\,\.\s]+$/}
                                    minChar={ 0 } 
                                    forceValidate={ props.forceValidate }
                                    forceValidateItems={ props.forceValidateItems } />
                            </div>
                            <div className="col">
                                <Input name={"credit-start-"+index}
                                    id={"othercredits-credit-start-"+index}
                                    required={ false }
                                    setFunction={ val =>  updateValue(val, index, 'creditStartDate')  }
                                    type="text"
                                    placehold={ "Rok udzielenia" }
                                    val={ item.creditStartDate }
                                    size="xxl" 
                                    regExp={/^[0-9\,\.\/]{0,4}$/}
                                    allowChars={/^[0-9\,\.\/]{0,4}$/}
                                    minChar={ 0 } 
                                    // customErrorText={"Zły format, wpisz MM-RRRR"}
                                    forceValidate={ props.forceValidate }
                                    forceValidateItems={ props.forceValidateItems } />
                            </div>
                            <div className="col">
                                <Input name={"credit-end-"+index}
                                    id={"othercredits-credit-end-"+index}
                                    required={ false }
                                    setFunction={ val => updateValue(val, index, 'creditEndDay') }
                                    type="text"
                                    placehold={ "Termin spłaty" }
                                    val={ item.creditEndDay }
                                    size="xxl" 
                                    regExp={/^[0-9\,\.\/]{0,15}$/}
                                    allowChars={/^[0-9\,\.\/]{0,15}$/}
                                    minChar={ 0 } 
                                    forceValidate={ props.forceValidate }
                                    forceValidateItems={ props.forceValidateItems }/>
                            </div>
                        </div>
                        </>
                    ))}
                </div>
                <div className="btns-real-estates">
                    { !disabledButton &&
                        <div className="col">
                            <div className="add-real-eastate">
                                <Button title="Dodaj zobowiązanie" class="blue reverse" add={ true } setFunction={ () => add() } />
                            </div>
                        </div>
                    }
                    { otherCreditsItems.length >= 1 &&
                        <div className="col">
                            <Button title="Usuń zobowiązanie" class="blue reverse" minus={ true } setFunction={ () => removeLastFromArray() } />
                        </div>
                    }
                </div>
                {otherCreditsItems.length > 0 &&
                    <div className="statement">
                        <Heading title="Oświadczam(y), że powyższe zobowiązania są płacone terminowo" small />
                        <div className="col">
                            <CheckboxRadio  required={ otherCreditsItems.length == 0 ? false : true } 
                                            setFunction={ (val) =>  dispatch({ type: 'STATEMENT_CREDITS_PAYMENT_CHECKBOX_CHANGE', value: val })}
                                            otherForceValidate={ props.forceValidate }
                                            val={ statementCreditsPaymentCheckbox}
                                            text="Tak" />

                            <CheckboxRadio  required={ otherCreditsItems.length == 0 ? false : true } 
                                            setFunction={ (val) =>  dispatch({ type: 'STATEMENT_CREDITS_PAYMENT_CHECKBOX_CHANGE', value: val })}
                                            otherForceValidate={ props.forceValidate }
                                            text="Nie" 
                                            val={ statementCreditsPaymentCheckbox } />
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default OtherCredits;